import { UrlApi } from "../../../../services/apirest";

const BASE_URL = `${UrlApi}/viandas2`;

const getToken = () => localStorage.getItem("token");

const buildQuery = (params) => {
  if (!params) return "";
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    usp.append(key, value);
  });
  const qs = usp.toString();
  return qs ? `?${qs}` : "";
};

const request = async (path, { method = "GET", params, body } = {}) => {
  const headers = { Authorization: `Bearer ${getToken()}` };
  if (body !== undefined) headers["Content-Type"] = "application/json";

  let response;
  try {
    response = await fetch(`${BASE_URL}${path}${buildQuery(params)}`, {
      method,
      headers,
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  } catch (err) {
    const netErr = new Error("Error de red. El servidor no responde.");
    netErr.status = 0;
    throw netErr;
  }

  let json = null;
  try {
    json = await response.json();
  } catch (err) {
    json = null;
  }

  if (!response.ok || json?.ok === false) {
    const message =
      json?.error || json?.message || `Error ${response.status}: Error de servidor.`;
    const apiError = new Error(message);
    apiError.status = response.status;
    apiError.apiMessage = json?.message;
    throw apiError;
  }

  return json;
};

export const viandas2Get = async (path, params) => {
  const json = await request(path, { method: "GET", params });
  return json?.data;
};

export const viandas2Post = (path, body) => request(path, { method: "POST", body });

export const viandas2Put = (path, body) => request(path, { method: "PUT", body });

export const viandas2Patch = (path, body) => request(path, { method: "PATCH", body });

export const viandas2Delete = (path) => request(path, { method: "DELETE" });

export const viandas2PostForm = async (path, formData) => {
  let response;
  try {
    response = await fetch(`${BASE_URL}${path}`, {
      method: "POST",
      headers: { Authorization: `Bearer ${getToken()}` },
      body: formData,
    });
  } catch (err) {
    const netErr = new Error("Error de red. El servidor no responde.");
    netErr.status = 0;
    throw netErr;
  }

  let json = null;
  try {
    json = await response.json();
  } catch (err) {
    json = null;
  }

  if (!response.ok || json?.ok === false) {
    const message =
      json?.error || json?.message || `Error ${response.status}: Error de servidor.`;
    const apiError = new Error(message);
    apiError.status = response.status;
    throw apiError;
  }

  return json;
};

const fetchBlob = async (path, params) => {
  const response = await fetch(`${BASE_URL}${path}${buildQuery(params)}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });

  if (!response.ok) {
    let message = `Error ${response.status}: Error de servidor.`;
    try {
      const json = await response.json();
      message = json?.error || json?.message || message;
    } catch (err) {
      // el error no vino en formato json (por ej. el propio archivo)
    }
    const apiError = new Error(message);
    apiError.status = response.status;
    throw apiError;
  }

  if (response.status === 204) return null;

  return response.blob();
};

export const viandas2Download = async (path, params, filename) => {
  const blob = await fetchBlob(path, params);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const viandas2OpenPdf = async (path, params) => {
  const blob = await fetchBlob(path, params);

  if (!blob) {
    return { abierta: false, sinDatos: true };
  }

  const url = window.URL.createObjectURL(blob);
  const nuevaPestana = window.open(url, "_blank");

  if (nuevaPestana) {
    nuevaPestana.focus();
    nuevaPestana.onload = () => {
      nuevaPestana.print();
    };
  }

  setTimeout(() => window.URL.revokeObjectURL(url), 15000);

  return { abierta: !!nuevaPestana, sinDatos: false };
};
